import axios from 'axios'
import md5 from '../utils/md5'
import { getToken, removeToken } from '../utils/auth'
import { Message } from 'element-ui'

import glo_loading from '../loading/index'
import { apiLoading } from '../loading/loadingConfig'
import { env } from '../utils/util'
let BASE_API_URL = env().apiUrl;

let loadingAntiShake
// console.log(process.env.VUE_APP_baseUrl)
// switch (process.env.NODE_ENV) {
//   case 'production':
//     BASE_API_URL = 'https://admin.api.yanhezhineng.com'
//     break
//   case 'test':
//     BASE_API_URL = 'http://api.admin.yanhezhineng.cn'
//     break
//   default:
//     // BASE_API_URL = 'http://localhost:9098'
//     BASE_API_URL = 'http://api.admin.yanhezhineng.cn'
//     break
// }

export const API_URL = BASE_API_URL
const httpService = axios.create({

  baseURL: BASE_API_URL,
  timeout: 10000 // 请求超时时间 10s
})

function startLoading() {

}

function stopLoading() {

}

export function requestHeaders(url) {
  // console.log('modemodemodemode-----')
  // console.log(process.env.NODE_ENV)
  // console.log('modemodemodemode#######')
  var salt = 'QWERTYUIOPLKMNBVCXZASDFGHJKJHGFEWQQ1234567890OKJHBVCXSWERT'
  var path = '/admin' + url
  var timestamp = Date.parse(new Date())
  var apiHeader = 'yhe-web-manage'
  var appId = 'com.yhe.manage-web'
  var appVersion = '1.0.0'

  var token = getToken()
  var tmp = salt + apiHeader + timestamp + path + appId + appVersion
  // console.log(tmp)
  var sign = md5.md5(tmp)
  var header = {}
  header['x-request-yanhe-api'] = apiHeader
  header['timestamp'] = timestamp
  header['app-id'] = appId
  header['app-version'] = appVersion
  header['sign'] = sign
  if (token != null) {
    header['auth-token'] = token
  }
  return header
}
var pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
var cancelToken = axios.CancelToken;
//重复请求相同接口时取消之前的接口请求
let removePending = (ever) => {
  for (let p in pending) {
    if (pending[p].u === ever.url + '&' + ever.method) { //当当前请求在数组中存在时执行函数体
      pending[p].f(); //执行取消操作
      pending.splice(p, 1); //把这条记录从数组中移除
    }

  }
}
// request拦截器
httpService.interceptors.request.use(
  config => {
    // clearTimeout(loadingAntiShake)
    // apiLoading ? glo_loading.loadingShow() : ''
    removePending(config);  //在一个ajax发送前执行一下取消操作
    config.cancelToken = new cancelToken((c) => {
      // 创建取消请求的唯一标识和取消函数
      pending.push({ u: config.url + '&' + config.method, f: c });
    });
    // console.log('------------------------------before--------headers--------------------------------------')
    // console.log(config.headers)
    let headers = requestHeaders(config.url)
    for (var key in headers) {
      config.headers[key] = headers[key]
    }

    // console.log('------------------------after--------headers-------------------------')
    // console.log(config.headers)
    return config
  },
  error => {
    // 请求错误处理
    return Promise.reject(error)
  }
)

// respone拦截器
httpService.interceptors.response.use(
  response => {
    // loadingAntiShake=setTimeout(()=>{
    // apiLoading ? glo_loading.loadingHide() : ''
    // })
    removePending(response.config);  //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
    let msg = response.data.msg
    let code = response.data.code
    // console.log("codecodecodecodecodecodecodecodecode")
    // console.log(code)
    if (code === 401) {
      removeToken()
      window.location.href = '/login'
      return null
    } else if (code != 1000) {
      console.log(msg);
      // Message.error(msg)
    }

    return response
  },
  // 处理处理
  error => {
    if (error && error.response) {

    } else {
      error.message = '连接到服务器失败'
    }
    return Promise.reject(error)
  }
)

/*网络请求部分*/

/*
 *  get请求
 *  url:请求地址
 *  params:参数
 * */
export function getRequest(url, params = {}) {
  // console.log('get request-------' + url)
  // console.log('get参数----------' + params)
  return new Promise((resolve, reject) => {
    httpService({

      url: url,
      method: 'GET',
      params: params

    }).then((response) => {
      // console.log('请求结果 -------')
      // console.log(response)
      resolve(response)
    }).catch((error) => {
      // console.log('请求错误--------' + error)
      reject(error)
    })
  })
}

/*
 *  post请求
 *  url:请求地址
 *  params:参数
 * */
export function postRequest(url, params = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url: url,
      method: 'POST',
      data: params
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

/*
 *  文件上传
 *  url:请求地址
 *  params:参数
 * */
export function fileUpload(url, params) {

  // console.log('----------------上传----------------')
  return new Promise((resolve, reject) => {
    httpService({
      url: url,
      method: 'post',
      data: params,
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export default {
  BASE_API_URL,
  API_URL,
  requestHeaders,
  httpService
}
